// @flow

import styled, { css } from 'styled-components';
import { media } from '@leasen_nl/listo/src/helpers';
import type { Theme } from '@types/index';

export const Title = styled<any, Theme>('p')`
  color: ${props => props.theme.news.titleColor};
  font-size: 1.125rem;
  font-weight: bold;
  margin: 0 1rem 0 0;
`;

export const Flex = styled<any, Theme>('div')`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

export const Wrapper = styled<any, Theme>('div')`
  max-width: 48rem;
  margin: 0 auto;
  padding: 0 1rem 2rem 1rem;
  ${media.sm(css`
    padding: 0 1rem 3rem 1rem;
  `)}
`;
